module.exports = __webpack_public_path__ + "static/media/no-broadcast-border.f0c81b67.png";